import { Divider, Stack, Typography } from "@mui/material"
import { Else } from "lib/@components/else"
import { Loader } from "lib/@components/Loader"
import { Frag } from "lib/@components/slot/frag"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { getAuditPayload } from "routes/audit/controller/get-audits-by-reference-id"

export function ApprovalMethod({ id }) {
    if (!id) return null
    const { data: payload, loading } = getAuditPayload.useResults.status(id)
    if (!payload?.approveAllStatus) return null
    const { approved, rejected, approveAll, firstPublish, comments } = payload.approveAllStatus

    if (loading) return <Loader inline size={12} color="primary" />

    return (
        <>
            <If truthy={approveAll}>
                <Divider orientation="horizontal" flexItem />
                <Stack direction={"row"} alignItems={"center"} spacing={1} mb={0.5}>
                    <Iconify sx={{ color: "success.main" }} icon="akar-icons:double-check" />
                    <Typography
                        variant={"body2"}
                        sx={{
                            color: "success.main",
                        }}
                    >
                        Approved all changes in one action
                    </Typography>
                </Stack>
            </If>
            <Else>
                <If truthy={firstPublish}>
                    <Frag />
                </If>
            </Else>
            <Else>
                <If truthy={approved && !rejected}>
                    <Divider orientation="horizontal" flexItem />
                    <Stack direction={"row"} alignItems={"center"} spacing={1} mb={0.5}>
                        <Typography variant={"body2"} sx={{ color: "success.main" }}>
                            Approved all changes individually
                        </Typography>
                    </Stack>
                </If>
            </Else>
            <Else>
                <If truthy={rejected}>
                    <Divider orientation="horizontal" flexItem />
                    <Stack spacing={1} mb={0.5}>
                        <Typography variant={"body2"} sx={{ color: "success.main" }}>
                            {approved} {"change".pluralize(approved)} approved
                        </Typography>
                        <Typography variant={"body2"} sx={{ color: "error.main" }}>
                            {rejected} {"change".pluralize(rejected)} rejected
                        </Typography>
                        <Typography variant={"body2"} sx={{ color: "primary" }}>
                            {comments} {"comment".pluralize(comments)} added
                        </Typography>
                    </Stack>
                </If>
            </Else>
        </>
    )
}
